import { useContext } from "react";
import { dashboardDateRangeContext } from "../context";

export const useDateRangeContext = () => {
  const { startDate, endDate, setDateRange } = useContext(dashboardDateRangeContext);

  return { startDate, endDate, setDateRange };
};
